import { useState } from 'react'
import { withSafeNext } from '../auth'
import FormErrors from '../components/FormErrors'
import { providerSignup } from '../lib/allauth'
import { Link, useLocation } from 'react-router-dom'
import { Card, Input, Button, Typography } from 'antd'

const { Title, Text } = Typography

export default function ProviderSignup () {
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [response, setResponse] = useState({ fetching: false, content: null })

  function submit () {
    setResponse({ ...response, fetching: true })
    providerSignup({ email }).then((content) => { setResponse((r) => { return { ...r, content } }) }).catch((e) => { console.error(e); window.alert(e) }).then(() => { setResponse((r) => { return { ...r, fetching: false } }) })
  }

  return (
    <div style={{ maxWidth: 380, margin: '48px auto' }}>
      <Card>
        <Title level={2} className='tti-page-title'>Sign Up</Title>
        <Text type='secondary' style={{ fontSize: 13 }}>Already have an account? <Link to={withSafeNext('/account/login', location.search)}>Login here.</Link></Text>
        <FormErrors errors={response.content?.errors} />
        <div style={{ marginTop: 16 }}>
          <label style={{ fontSize: 12, color: 'var(--tti-muted)' }}>Email</label>
          <Input value={email} onChange={(e) => setEmail(e.target.value)} type='email' style={{ marginTop: 4 }} />
          <FormErrors param='email' errors={response.content?.errors} />
        </div>
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <Button type='primary' loading={response.fetching} onClick={() => submit()}>Sign Up</Button>
        </div>
      </Card>
    </div>
  )
}
